export default "__VITE_ASSET__b0a1897e__"